import React, { Component } from "react";
import { translate } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import InputFormat from "../inputForm";
import CountryRegionData from "./data.json";
import settings from "./settings";
import * as helpers from "./helpers";
class CountryDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countries: helpers.filterCountries(
        CountryRegionData,
        props.priorityOptions,
        props.whitelist,
        props.blacklist
      )
    };
  }

  getCountries() {
    const { valueType, labelType } = this.props;
    let { countries = [] } = this.state;
    return countries.map(country => (
      <MenuItem
        key={country.countryShortCode}
        value={
          valueType === settings.DISPLAY_TYPE_SHORT
            ? country.countryShortCode
            : country.countryName
        }
      >
        {labelType === settings.DISPLAY_TYPE_SHORT
          ? country.countryShortCode
          : country.countryName}
      </MenuItem>
    ));
  }

  getDefaultOption() {
    const {
      showDefaultOption,
      defaultOptionLabel,
      placeholder,
      blankOptionLabel
    } = this.props;

    if (!showDefaultOption) {
      return null;
    }
    return (
      <MenuItem key="default" value=" ">
        {blankOptionLabel || defaultOptionLabel || placeholder}
      </MenuItem>
    );
  }

  render() {
    const {
      t,
      label,
      value,
      onChange,
      onBlur,
      id,
      name,
      disabled,
      classes,
      disable,
      InputLabelProps = {},
      SelectProps = {},
      ...arbitraryProps
    } = this.props;

    const attrs = {
      ...arbitraryProps,
      name,
      label,
      value,
      onChange: e => onChange(e),
      onBlur: e => onBlur(e),
      disabled
    };
    if (id) {
      attrs.id = id;
    }
    if (classes) {
      attrs.className = classes;
    }

    return (
      <InputFormat
        {...attrs}
        select
        SelectProps={{
          displayEmpty: true,
          ...SelectProps
        }}
        InputLabelProps={{
          ...InputLabelProps
        }}
      >
        {this.getDefaultOption()}
        {this.getCountries()}
      </InputFormat>
    );
  }
}
const styles = theme => ({
  title: {
    fontSize: "1.5rem"
  },
  textField: {
    marginRight: theme.spacing(1),
    width: "100%"
  },
  input: {},
  label: {
    fontWeight: 410
  }
});

CountryDropdown.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  id: PropTypes.string,
  classes: PropTypes.object,
  showDefaultOption: PropTypes.bool,
  defaultOptionLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  priorityOptions: PropTypes.array,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  labelType: PropTypes.oneOf([
    settings.DISPLAY_TYPE_FULL,
    settings.DISPLAY_TYPE_SHORT
  ]),
  valueType: PropTypes.oneOf([
    settings.DISPLAY_TYPE_FULL,
    settings.DISPLAY_TYPE_SHORT
  ]),
  whitelist: PropTypes.array,
  blacklist: PropTypes.array,
  placeholder: PropTypes.string,
  disableUnderline: PropTypes.bool,
  disabled: PropTypes.bool
};
CountryDropdown.defaultProps = {
  value: "",
  name: "rcrs-country",
  id: "",
  classes: {},
  showDefaultOption: true,
  defaultOptionLabel: "Select Country",
  priorityOptions: [],
  onChange: () => { },
  onBlur: () => { },
  labelType: settings.DISPLAY_TYPE_FULL,
  valueType: settings.DISPLAY_TYPE_FULL,
  whitelist: [],
  blacklist: [],
  disabled: false
};
export default translate("translations")(
  withStyles(styles, { withTheme: true })(CountryDropdown)
);
